export default {
	activityLabel: "Activity",
	detailsLabel: "Details",
};
